/**
 * Created by slava on 19/3/20
 */

const WildCardButton = BaseButtonBooster.extend({ 
    ctor: function (booster) {
        this._super({
            booster,
            styles: cleverapps.styles.WildCardButtonBooster,
            spine: bundles.game.jsons.joker_button_json
        });

        booster.onCardCreatedListener = this.createListener(this.createCardView.bind(this));

        this.onResize();
        this.setLocalZOrder(10);

        if (this.hoverHandler) {
            this.hoverHandler.remove();
            this.hoverHandler = undefined;
        }

        cleverapps.UI.applyHover(this.background);
    },

    createFreePrice: function () {
        // eslint-disable-next-line no-restricted-syntax
        const freeText = cleverapps.UI.generateTTFText(Messages.get("FREE"), cleverapps.styles.FONTS.BUTTON_BOOSTER);
        freeText.fitTo(this.priceBlock.width);
        this.priceBlock.addChild(freeText);
        freeText.setAlignment(this.priceBlock.width / 2, this.priceBlock.height / 2);
        return freeText;
    },

    onResize: function () {
        this.baseScale = 1;
        this.setScale(this.baseScale);
        this.setAlignment(cleverapps.styles.WildCardButtonBooster.position);
    },

    toggleArrow: function () {
    },

    toggleTint: function (on) {
        if (on) {
            this.showAlert();
        }
    },

    getContent: function (isOff = false) {
        if (isOff) {
            return this._super(isOff);
        }

        const styles = cleverapps.styles.WildCardButtonBooster.price;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);

        const price = this.price = this.priceText = new TextWithIcon(`$$${this.booster.getPrice().amount}`, {
            font: cleverapps.styles.FONTS.TEXT
        });

        const priceBlock = this.priceBlock = new cc.Scale9Sprite(bundles.small_timer.frames.small_timer_bg_png);
        priceBlock.setContentSize2(price.width + 2 * styles.bg.padding.x, price.height + 2 * styles.bg.padding.y);
        content.addChild(priceBlock);
        priceBlock.addChild(price);
        price.setAlignment(priceBlock.width / 2, priceBlock.height / 2);
        priceBlock.setAlignment(styles);

        const amount = this.amount = this.amountText = cleverapps.UI.generateImageText(`x${this.booster.getAmount()}`, cleverapps.styles.FONTS.AMOUNT_BOOSTER);
        amount.setAlignment(priceBlock.width / 2, priceBlock.height / 2);
        priceBlock.addChild(amount);

        const ads = this.ads = this.amountText = new TextWithIcon(`## ${Messages.get("FREE")}`, {
            font: cleverapps.styles.FONTS.BUTTON_BOOSTER
        });
        ads.setAlignment(priceBlock.width / 2, priceBlock.height / 2);
        ads.fitTo(price.width);
        priceBlock.addChild(ads);
        return content;
    },

    createCardView: function (card) {
        const ViewClass = card.getViewClass();
        const view = new ViewClass(card);
        view.setPosition(this.width / 2, this.height / 2);
        this.addChild(view);
    },

    switchToRegularPrice: function () {
        if (!this.booster.wildcardTutorial) {
            this._super.call(this);
        }
    }
});

cleverapps.styles.WildCardButtonBooster = {
    width: 116,
    height: 165,

    price: {
        x: { align: "center" },
        y: { align: "bottom", dy: -103 },

        bg: {
            padding: {
                x: 5,
                y: 1
            }
        }
    },

    position: {
        x: { align: "right", dx: 0 },
        y: { align: "bottom", dy: 21 }
    },

    content: {
        price: {
            x: { align: "center" },
            y: { align: "bottom", dy: -50 },
            scale: 0.7
        },
        layout: {
            x: { align: "center" },
            y: { align: "center" }
        }
    }
};